import { useFieldArray, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
//@ts-ignore
import { FormLayout } from "@careinfo/layout";
import { useEffect, useRef, useState } from "react";
import APIS from "../../constant/EndPoint";
import Button from "../Reusable/Button";
import Modal from "../Reusable/Modal";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { getApiData, postApiData } from "../../helpers/AxiosInstance";
import { createConsignmentValidationForm } from "../../utils/validationSchemas";
import EditConsignmentForm from "./EditConsignmentForm";

const EditConsignment = (props: any) => {
  const [isManualFreight, setIsManualFreight] = useState(false);
  const navigate = useNavigate();
  const [openExtraChargePopup, setOpenExtraChargePopup] = useState(false);
  const [senderId, setSenderId] = useState<any>(null);
  const [receiverId, setReceiverId] = useState<any>(null);
  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    setFocus,
    watch,
    reset,
    getValues,
    clearErrors,
  } = useForm<any>({
    defaultValues: async () => {
      let order = props?.order;
      if (order?.delivery_charge) {
        setIsManualFreight(true);
      }
      return {
        pickup_branch: order.pickup_branch,
        destination: order?.destination,
        vendor: order?.merchant,
        sender_full_name: order?.sender?.full_name,
        receiver_full_name: order?.receiver?.full_name,
        sender_phone_number: order?.sender?.primary_contact,
        receiver_phone_number: order?.receiver?.primary_contact,
        sender_vat_pan: order?.sender?.vat_pan,
        receiver_vat_pan: order?.receiver?.vat_pan,
        sender_address: order?.sender?.address,
        receiver_address: order?.receiver?.address,
        service_type: order?.service_type,
        payment_method: order?.payment_method,
        hawb_no: order?.hawb_no,
        ship_via: order?.ship_via,
        reference_type: order?.reference_type,
        reference_date: order?.reference_date,
        reference_number: order?.reference_number,
        order_value: order?.order_value,
        cod: order?.cod,
        note: order?.note,
        extra_charges: {
          // freight: order?.extra_charges?.freight ?? 0,
          // pickup: order?.extra_charges?.pickup ?? 0,
          // other: order?.extra_charges?.other ?? 0,
          st: order?.extra_charges?.st ?? 0,
          // labour: order?.extra_charges?.labour ?? 0,
        },
        delivery_charge: order?.delivery_charge,
        order_items: order?.children?.map((item: any, index: number) => ({
          package_type: { ...item?.package_type },
          calculated_by: {
            id: item?.calculated_by,
            name: item?.calculated_by,
          },
          piece: item?.pieces ? Math.trunc(parseFloat(item?.pieces)) : 1,
          weight: item?.weight ? Math.trunc(parseFloat(item?.weight)) : 0,
          rate: item?.rate,
          remark: item?.note,
        })),
      };
    },
    resolver: yupResolver(createConsignmentValidationForm),
  });

  const {
    handleEdit,
    isLoading,
    setOpenAddReceiverPopup,
    openAddReceiverPopup,
    openAddSenderPopup,
    setOpenAddSenderPopup,
    openPrintPopup,
    setOpenPrintPopup,
    profile,
    handleLabelPrintDownload,
    handleOrderReceiptDownload,
    isPrintLoading,
  } = props;

  const { fields, append, remove } = useFieldArray({
    control,
    name: "order_items",
  });

  const vendor = getValues("vendor");
  const pickup = getValues("pickup_branch");
  const destination = getValues("destination");
  const OrderItems = watch("order_items");
  const FreightCharge = watch("delivery_charge");
  // const PickupCharge = watch("extra_charges.pickup");
  // const LabourCharge = watch("extra_charges.labour");
  // const DeliveryCharge = watch("extra_charges.freight");
  const StCharge = watch("extra_charges.st");
  // const OtherCharge = watch("extra_charges.other");
  const [prevData, setPrevData] = useState({
    merchant: props?.order?.merchant?.id,
    pickup_branch: props?.order?.pickup_branch?.id,
    destination: props?.order?.destination?.id,
  });

  const handleSetCustomerDefaultValue = async (
    merchantId: any,
    pickup_branch: any,
    destination: any
  ) => {
    const url = `${APIS.ORDER}location-wise-customer/`;
    const formData = {
      vendor: merchantId?.id ?? merchantId,
      pickup_branch: pickup_branch?.id ?? pickup_branch,
      destination: destination?.id ?? destination,
    };
    const res = await postApiData({ url, formData, setError });
    if (res.status === 200) {
      setValue("sender_full_name", res?.data?.sender_name);
      setValue("receiver_full_name", res?.data?.receiver_name);
      setValue("sender_address", res?.data?.sender_address);
      setValue("receiver_address", res?.data?.receiver_address);
      setValue("sender_phone_number", res?.data?.sender_primary_contact);
      setValue("receiver_phone_number", res?.data?.receiver_primary_contact);
      setValue("sender_vat_pan", res?.data?.sender_vat_pan);
      setValue("receiver_vat_pan", res?.data?.receiver_vat_pan);
      setValue("vendor", merchantId);
      setPrevData({
        merchant: merchantId?.id ?? merchantId,
        pickup_branch: pickup_branch?.id ?? pickup_branch,
        destination: destination?.id ?? destination,
      });
    }
  };

  const handleSenderAutoFillValue = async (senderId: any) => {
    const url = `${APIS.CUSTOMER}${senderId}/`;
    const res = await getApiData(url, {});
    if (res.status === 200) {
      setValue("sender_address", res?.data?.address);
      setValue("sender_phone_number", res?.data?.primary_contact);
      setValue("sender_vat_pan", res?.data?.vat_pan);
    }
  };
  const handleReceiverAutoFillValue = async (receiverId: any) => {
    const url = `${APIS.CUSTOMER}${receiverId}/`;
    const res = await getApiData(url, {});
    if (res.status === 200) {
      setValue("receiver_address", res?.data?.address);
      setValue("receiver_phone_number", res?.data?.primary_contact);
      setValue("receiver_vat_pan", res?.data?.vat_pan);
    }
  };
  const handleClosePrintPopup = () => {
    navigate("/create");
    setOpenPrintPopup(false);
  };
  const handleCloseModalPopup = (value: any) => {
    window.location.replace("/order");
    setOpenPrintPopup(value);
  };
  const vendorRef = useRef(null);
  useEffect(() => {
    if (vendorRef?.current) {
      vendorRef.current.focus();
    }
  }, [vendorRef]);

  useEffect(() => {
    const isVendorChanged =
      vendor !== prevData?.merchant && vendor?.id !== prevData?.merchant;
    const isPickupChanged =
      pickup !== prevData?.pickup_branch &&
      pickup?.id !== prevData?.pickup_branch;
    const isDestinationChanged =
      destination !== prevData?.destination &&
      destination?.id !== prevData?.destination;
    if (
      (isVendorChanged || isPickupChanged || isDestinationChanged) &&
      vendor &&
      pickup &&
      destination
    ) {
      setValue("sender_full_name", null);
      setValue("receiver_full_name", null);
      handleSetCustomerDefaultValue(vendor, pickup, destination);
    }
  }, [vendor, pickup, destination, setValue, props]);

  useEffect(() => {
    if (!senderId) return;
    handleSenderAutoFillValue(senderId);
  }, [senderId]);

  useEffect(() => {
    if (!receiverId) return;
    handleReceiverAutoFillValue(receiverId);
  }, [receiverId]);

  const calculateTotalDeliveryCharge = (items) => {
    if (!items) return;
    return items.reduce((total, item) => {
      const weight = Number(item?.weight) || 0;
      const piece = Number(item?.piece) || 0;
      const rate = Number(item?.rate) || 0;
      if (item?.calculated_by?.id === "weight") {
        return total + weight * rate;
      } else {
        return total + piece * rate;
      }
    }, 0);
  };

  const totalDeliveryCharge = calculateTotalDeliveryCharge(OrderItems);

  // useEffect(() => {
  //   setValue("delivery_charge", totalDeliveryCharge);
  // }, [totalDeliveryCharge]);

  useEffect(() => {
    if (isManualFreight) return;
    const hasRate = OrderItems?.some((item) => Number(item?.rate) > 0);
    if (!hasRate) return;

    setValue("delivery_charge", totalDeliveryCharge);
  }, [totalDeliveryCharge, isManualFreight]);

  useEffect(() => {
    const TotalCharge =
      // Number(PickupCharge) +
      // Number(DeliveryCharge) +
      // Number(LabourCharge) +
      Number(StCharge) + Number(FreightCharge);
    // Number(OtherCharge);
    setValue("total_charge", TotalCharge);
  }, [
    // PickupCharge,
    // DeliveryCharge,
    // LabourCharge,
    StCharge,
    FreightCharge,
    // OtherCharge,
    setValue,
  ]);

  return (
    <>
      <FormLayout
        handleSubmit={handleSubmit}
        handleFormSubmit={handleEdit}
        setError={setError}
        disabled={props?.order?.invoice_id}
        buttonLabel={"Update"}
        isLoading={isLoading}
      >
        <EditConsignmentForm
          control={control}
          profile={profile}
          clearErrors={clearErrors}
          errors={errors}
          register={register}
          setValue={setValue}
          setFocus={setFocus}
          vendorRef={vendorRef}
          getValues={getValues}
          watch={watch}
          openAddReceiverPopup={openAddReceiverPopup}
          setOpenAddReceiverPopup={setOpenAddReceiverPopup}
          openAddSenderPopup={openAddSenderPopup}
          setOpenAddSenderPopup={setOpenAddSenderPopup}
          setOpenExtraChargePopup={setOpenExtraChargePopup}
          openExtraChargePopup={openExtraChargePopup}
          fields={fields}
          append={append}
          remove={remove}
          setSenderId={setSenderId}
          setReceiverId={setReceiverId}
          setIsManualFreight={setIsManualFreight}
        />
      </FormLayout>
      <Modal
        isOpen={openPrintPopup}
        setIsOpen={handleCloseModalPopup}
        title={"Print "}
      >
        <div className={tw`w-[600px]`}>
          <Button
            label={"Print Label"}
            isLoading={isPrintLoading}
            disabled={isPrintLoading}
            onClick={handleLabelPrintDownload}
          />
          <Button
            label={"Print Receipt"}
            isLoading={isPrintLoading}
            disabled={isPrintLoading}
            onClick={handleOrderReceiptDownload}
          />
          <Button label={"Close"} onClick={handleClosePrintPopup} />
        </div>
      </Modal>
    </>
  );
};

export default EditConsignment;
